import { up } from 'styled-breakpoints';
import styled from 'styled-components';

const ListWrapper = styled.div`
  padding: 24px 20px;
  color: ${(props) => props.theme.colors.grayDark4};

  ${up('md')} {
    padding: 24px 10px;
  }

  ${up('lg')} {
    padding: 24px 240px;
  }
`;

export default ListWrapper;
